import Vue from "vue";
import App from "./App.vue";
import axios from 'axios'

// 引入vuerouter
import VueRouter from "vue-router";
import router from "./router";

// 引入elementui组件库
import ElementUI from "element-ui";

// vuex
import store from './store'

// 引入css样式
import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconfont.css";
import "./assets/base.less";
import "./assets/css/webCss/public.css";

// 引入VideoPlayer
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'

// 响应式最终兜底补丁，必须放在样式 import 最后
import "./assets/css/responsive-fix.css";

Vue.use(VideoPlayer)
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(VideoPlayer)

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
